import { createStyles, Theme, makeStyles } from '@material-ui/core';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    summaryWrapper: {
      marginBottom: 60,
      [theme.breakpoints.up('md')]: {
        marginBottom: 90,
      },
    },
    summaryLoaderWrapper: {
      height: 300,
      position: 'relative',
    },
    tabText: {
      overflowX: 'auto',
      maxWidth: '100%',
      fontSize: 16,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      '& h1,& h2,& h3,& h4,& h5,& h6,& p,& ul,& ol': {
        marginBottom: 18,
      },
      '& h1,& h2,& h3,& h4,& h5,& h6': {
        color: colorsPalette.white,
        lineHeight: 1.5,
      },
      '& ul, & ol': {
        paddingLeft: 20,
        '& li': {
          '&::marker': {
            color: colorsPalette.turquoiseLight,
          },
        },
      },
      '& svg g': {
        fill: colorsPalette.white,
        stroke: colorsPalette.white,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        marginBottom: 30,
      },
    },
    imageWrapper: {
      padding: 18,
      marginTop: 18,
      marginBottom: 18,
      background: theme.palette.secondary.light,
      display: 'flex',
      justifyContent: 'center',
      borderRadius: 5,
      '& img': {
        maxWidth: '100%',
        height: 'auto',
      },
      [theme.breakpoints.up('md')]: {
        padding: 36,
        marginTop: 36,
        marginBottom: 36,
      },
    },
  }),
);

export default useStyles;
